import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { setPostPayload, setPutPayload } from "../../services/api";
import ProctorCompactionDetails from "./ProctorCompactionDetails";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ProctorCompaction = ({
  data,
  selectedTest,
  loggedUser,
  setOpenReportDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });

  const [chartData, setChartData] = useState({
    waterAddedText: "Water Added",
    waterAdded1: 0.0,
    waterAdded2: 0.0,
    waterAdded3: 0.0,
    waterAdded4: 0.0,
    waterAdded5: 0.0,

    cylinderWetSoilText: "Wt. Cylinder + Wet Soil (g)",
    cylinderWetSoil1: 0.0,
    cylinderWetSoil2: 0.0,
    cylinderWetSoil3: 0.0,
    cylinderWetSoil4: 0.0,
    cylinderWetSoil5: 0.0,

    cylinderText: "Wt. of Cylinder (g)",
    cylinder1: 0.0,
    cylinder2: 0.0,
    cylinder3: 0.0,
    cylinder4: 0.0,
    cylinder5: 0.0,

    wetSoilText: "Wt. of Wet Soil (g)",
    wetSoil1: 0.0,
    wetSoil2: 0.0,
    wetSoil3: 0.0,
    wetSoil4: 0.0,
    wetSoil5: 0.0,

    bulkWeightText: "Bulk Unit Weight (g/cm3)",
    bulkWeight1: 0.0,
    bulkWeight2: 0.0,
    bulkWeight3: 0.0,
    bulkWeight4: 0.0,
    bulkWeight5: 0.0,

    tinNoText: "Tin No",
    tinNo1_1: 0.0,
    tinNo1_2: 0.0,
    tinNo2_1: 0.0,
    tinNo2_2: 0.0,
    tinNo3_1: 0.0,
    tinNo3_2: 0.0,
    tinNo4_1: 0.0,
    tinNo4_2: 0.0,
    tinNo5_1: 0.0,
    tinNo5_2: 0.0,

    tinWetSoilText: "Wt. of Tin + Wet Soil (g)",
    tinWetSoil1_1: 0.0,
    tinWetSoil1_2: 0.0,
    tinWetSoil2_1: 0.0,
    tinWetSoil2_2: 0.0,
    tinWetSoil3_1: 0.0,
    tinWetSoil3_2: 0.0,
    tinWetSoil4_1: 0.0,
    tinWetSoil4_2: 0.0,
    tinWetSoil5_1: 0.0,
    tinWetSoil5_2: 0.0,

    tinDrySoilTExt: "Wt. of Tin + Dry Soil (g)",
    tinDrySoil1_1: 0.0,
    tinDrySoil1_2: 0.0,
    tinDrySoil2_1: 0.0,
    tinDrySoil2_2: 0.0,
    tinDrySoil3_1: 0.0,
    tinDrySoil3_2: 0.0,
    tinDrySoil4_1: 0.0,
    tinDrySoil4_2: 0.0,
    tinDrySoil5_1: 0.0,
    tinDrySoil5_2: 0.0,

    tinText: "Wt. of Tin  (g)",
    tin1_1: 0.0,
    tin1_2: 0.0,
    tin2_1: 0.0,
    tin2_2: 0.0,
    tin3_1: 0.0,
    tin3_2: 0.0,
    tin4_1: 0.0,
    tin4_2: 0.0,
    tin5_1: 0.0,
    tin5_2: 0.0,

    waterText: "Wt. of Water (g)",
    water1_1: 0.0,
    water1_2: 0.0,
    water2_1: 0.0,
    water2_2: 0.0,
    water3_1: 0.0,
    water3_2: 0.0,
    water4_1: 0.0,
    water4_2: 0.0,
    water5_1: 0.0,
    water5_2: 0.0,

    waterDrySoilText: "Wt. of Dry Soil (g)",
    waterDrySoil1_1: 0.0,
    waterDrySoil1_2: 0.0,
    waterDrySoil2_1: 0.0,
    waterDrySoil2_2: 0.0,
    waterDrySoil3_1: 0.0,
    waterDrySoil3_2: 0.0,
    waterDrySoil4_1: 0.0,
    waterDrySoil4_2: 0.0,
    waterDrySoil5_1: 0.0,
    waterDrySoil5_2: 0.0,

    mcText: "M.C. %",
    mc1_1: 0.0,
    mc1_2: 0.0,
    mc2_1: 0.0,
    mc2_2: 0.0,
    mc3_1: 0.0,
    mc3_2: 0.0,
    mc4_1: 0.0,
    mc4_2: 0.0,
    mc5_1: 0.0,
    mc5_2: 0.0,

    averageMcText: "Average M.C.",
    averageMc1_1: 0.0,
    averageMc1_2: 0.0,
    averageMc2_1: 0.0,
    averageMc2_2: 0.0,
    averageMc3_1: 0.0,
    averageMc3_2: 0.0,
    averageMc4_1: 0.0,
    averageMc4_2: 0.0,
    averageMc5_1: 0.0,
    averageMc5_2: 0.0,

    dryUnitWeightText: "Dry Unit Weight (g/cm3)",
    dryUnitWeight1_1: 0.0,
    dryUnitWeight1_2: 0.0,
    dryUnitWeight2_1: 0.0,
    dryUnitWeight2_2: 0.0,
    dryUnitWeight3_1: 0.0,
    dryUnitWeight3_2: 0.0,
    dryUnitWeight4_1: 0.0,
    dryUnitWeight4_2: 0.0,
    dryUnitWeight5_1: 0.0,
    dryUnitWeight5_2: 0.0,
  });

  const calculationOfChart = () => {
    setChartData((pre) => ({
      ...pre,
      wetSoil1: pre.cylinderWetSoil1 - pre.cylinder1,
      wetSoil2: pre.cylinderWetSoil2 - pre.cylinder2,
      wetSoil3: pre.cylinderWetSoil3 - pre.cylinder3,
      wetSoil4: pre.cylinderWetSoil4 - pre.cylinder4,
      wetSoil5: pre.cylinderWetSoil5 - pre.cylinder5,

      bulkWeight1: ((pre.cylinderWetSoil1 - pre.cylinder1) / 995).toFixed(3),
      bulkWeight2: ((pre.cylinderWetSoil2 - pre.cylinder2) / 995).toFixed(3),
      bulkWeight3: ((pre.cylinderWetSoil3 - pre.cylinder3) / 995).toFixed(3),
      bulkWeight4: ((pre.cylinderWetSoil4 - pre.cylinder4) / 995).toFixed(3),
      bulkWeight5: ((pre.cylinderWetSoil5 - pre.cylinder5) / 995).toFixed(3),

      water1_1: pre.tinWetSoil1_1 - pre.tinDrySoil1_1,
      water1_2: pre.tinWetSoil1_2 - pre.tinDrySoil1_2,
      water2_1: pre.tinWetSoil2_1 - pre.tinDrySoil2_1,
      water2_2: pre.tinWetSoil2_2 - pre.tinDrySoil2_2,
      water3_1: pre.tinWetSoil3_1 - pre.tinDrySoil3_1,
      water3_2: pre.tinWetSoil3_2 - pre.tinDrySoil3_2,
      water4_1: pre.tinWetSoil4_1 - pre.tinDrySoil4_1,
      water4_2: pre.tinWetSoil4_2 - pre.tinDrySoil4_2,
      water5_1: pre.tinWetSoil5_1 - pre.tinDrySoil5_1,
      water5_2: pre.tinWetSoil5_2 - pre.tinDrySoil5_2,

      waterDrySoil1_1: pre.tinDrySoil1_1 - pre.tin1_1,
      waterDrySoil1_2: pre.tinDrySoil1_2 - pre.tin1_2,
      waterDrySoil2_1: pre.tinDrySoil2_1 - pre.tin2_1,
      waterDrySoil2_2: pre.tinDrySoil2_2 - pre.tin2_2,
      waterDrySoil3_1: pre.tinDrySoil3_1 - pre.tin3_1,
      waterDrySoil3_2: pre.tinDrySoil3_2 - pre.tin3_2,
      waterDrySoil4_1: pre.tinDrySoil4_1 - pre.tin4_1,
      waterDrySoil4_2: pre.tinDrySoil4_2 - pre.tin4_2,
      waterDrySoil5_1: pre.tinDrySoil5_1 - pre.tin5_1,
      waterDrySoil5_2: pre.tinDrySoil5_2 - pre.tin5_2,

      waterDrySoil1_1: pre.tinDrySoil1_1 - pre.tin1_1,
      waterDrySoil1_2: pre.tinDrySoil1_2 - pre.tin1_2,
      waterDrySoil2_1: pre.tinDrySoil2_1 - pre.tin2_1,
      waterDrySoil2_2: pre.tinDrySoil2_2 - pre.tin2_2,
      waterDrySoil3_1: pre.tinDrySoil3_1 - pre.tin3_1,
      waterDrySoil3_2: pre.tinDrySoil3_2 - pre.tin3_2,
      waterDrySoil4_1: pre.tinDrySoil4_1 - pre.tin4_1,
      waterDrySoil4_2: pre.tinDrySoil4_2 - pre.tin4_2,
      waterDrySoil5_1: pre.tinDrySoil5_1 - pre.tin5_1,
      waterDrySoil5_2: pre.tinDrySoil5_2 - pre.tin5_2,
    }));

    console.log("total ", chartData);
  };

  const calculationOfChartFinalVal = () => {
    setChartData((pre) => ({
      ...pre,
      mc1_1: (pre.water1_1 / pre.waterDrySoil1_1) * 100,
    }));
  };

  console.log(chartData);

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "5000",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "PROC",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    rejectReason: "",
  });

  const concreteMixtureArray = [{ id: 1, label: "19 mm", value: "19 mm" }];

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    loadBasicData();
    // setTimeout(() => {
    //   calculationOfChart();
    // }, 5000);
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    // console.log("selectedid ", selectedTest.id);
    setLoading(true);

    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        // console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
          //   console.log("asss", response.data);
          const chartTableData =
            response.data.labTestFormData.labTestsDataFromSubs;
          //   console.log("data ,", chartTableData);

          //   console.log("read data", mainData);

          const totalValueOfWeight =
            Number(chartData.weight3750) +
            Number(chartData.weight20) +
            Number(chartData.weight14) +
            Number(chartData.weight10) +
            Number(chartData.weight05) +
            Number(chartData.weight0);

          setChartData((pre) => ({
            ...pre,
            weight3750: chartTableData[0]?.weightRetained.toFixed(3),
            retain3750: chartTableData[0]?.retained,
            cum3750: chartTableData[0]?.cum,
            passing3750: chartTableData[0]?.passing,

            weight20: chartTableData[1]?.weightRetained,
            retain20: chartTableData[1]?.retained,
            cum20: chartTableData[1]?.cum,
            passing20: chartTableData[1]?.passing,

            weight14: chartTableData[2]?.weightRetained.toFixed(3),
            retain14: chartTableData[2]?.retained,
            cum14: chartTableData[2]?.cum,
            passing14: chartTableData[2]?.passing,

            weight10: chartTableData[3]?.weightRetained.toFixed(3),
            retain10: chartTableData[3]?.retained,
            cum10: chartTableData[3]?.cum,
            passing10: chartTableData[3]?.passing,

            weight05: chartTableData[4]?.weightRetained.toFixed(3),
            retain05: chartTableData[4]?.retained,
            cum05: chartTableData[4]?.cum,
            passing05: chartTableData[4]?.passing,

            weight0: chartTableData[5]?.weightRetained.toFixed(3),
            retain0: chartTableData[5]?.retained,
            cum0: chartTableData[5]?.cum,
            passing0: chartTableData[5]?.passing,

            totalValueOfWeight:
              Number(chartTableData[0]?.weightRetained) +
              Number(chartTableData[1]?.weightRetained) +
              Number(chartTableData[2]?.weightRetained) +
              Number(chartTableData[3]?.weightRetained) +
              Number(chartTableData[4]?.weightRetained) +
              Number(chartTableData[5]?.weightRetained),

            spec3750pass:
              Number(chartTableData[0]?.passing) >= Number(pre.spec3750min) &&
              Number(chartTableData[0]?.passing) <= Number(pre.spec3750max)
                ? true
                : false,
            spec20pass:
              Number(chartTableData[1]?.passing) >= Number(pre.spec20min) &&
              Number(chartTableData[1]?.passing) <= Number(pre.spec20max)
                ? true
                : false,
            spec14pass:
              Number(chartTableData[2]?.passing) >= Number(pre.spec14min) &&
              Number(chartTableData[2]?.passing) <= Number(pre.spec14max)
                ? true
                : false,
            spec10pass:
              Number(chartTableData[3]?.passing) >= Number(pre.spec10min) &&
              Number(chartTableData[3]?.passing) <= Number(pre.spec10max)
                ? true
                : false,
            spec05pass:
              Number(chartTableData[4]?.passing) >= Number(pre.spec05min) &&
              Number(chartTableData[4]?.passing) <= Number(pre.spec05max)
                ? true
                : false,
          }));
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const addTestHandle = () => {
    // console.log("added test data ", eachTest);

    const updatedTest = {
      ...eachTest, // or pre if it's based on previous state
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: "22500",
      concreteMixture: mainData.concreteMixture,
    };

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: [...pre.labTestsDataFromSubs, updatedTest],
    }));
  };

  const rearrangeChartArray = () => {
    const sieveArray = [];

    sieveArray.push(
      {
        sieveSize: Number(chartData.sieve3750).toFixed(3),
        weightRetained: Number(chartData.weight3750).toFixed(3),
        retained: Number(chartData.retain3750).toFixed(3),
        cum: Number(chartData.cum3750).toFixed(3),
        passing: Number(chartData.passing3750).toFixed(3),
        color: chartData.spec3750,
        description: chartData.spec3750pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve20).toFixed(3),
        weightRetained: Number(chartData.weight20).toFixed(3),
        retained: Number(chartData.retain20).toFixed(3),
        cum: Number(chartData.cum20).toFixed(3),
        passing: Number(chartData.passing20).toFixed(3),
        color: chartData.spec20,
        description: chartData.spec20pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve14).toFixed(3),
        weightRetained: Number(chartData.weight14).toFixed(3),
        retained: Number(chartData.retain14).toFixed(3),
        cum: Number(chartData.cum14).toFixed(3),
        passing: Number(chartData.passing14).toFixed(3),
        color: chartData.spec14,
        description: chartData.spec14pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve10).toFixed(3),
        weightRetained: Number(chartData.weight10).toFixed(3),
        retained: Number(chartData.retain10).toFixed(3),
        cum: Number(chartData.cum10).toFixed(3),
        passing: Number(chartData.passing10).toFixed(3),
        color: chartData.spec10,
        description: chartData.spec10pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve05).toFixed(3),
        weightRetained: Number(chartData.weight05).toFixed(3),
        retained: Number(chartData.retain05).toFixed(3),
        cum: Number(chartData.cum05).toFixed(3),
        passing: Number(chartData.passing05).toFixed(3),
        color: chartData.spec05,
        description: chartData.spec05pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve0).toFixed(3),
        weightRetained: Number(chartData.weight0).toFixed(3),
        retained: Number(chartData.retain0).toFixed(3),
        cum: Number(chartData.cum0).toFixed(3),
        passing: Number(chartData.passing0).toFixed(3),
        color: chartData.spec0,
        description: chartData.spec0pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
    );
    return sieveArray;
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);

      //Add sieve data details to main objec array

      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "PROC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };
      console.log("main data save sendObject ", sendObject);
      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)

        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: mainData.id,
      }));

      console.log("***asss*********", mainData);

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "PROC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };

      console.log("************", sendObject);

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}

      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header
          title="PROCTOR COMPACTION TEST REPORT."
          subtitle="GENERAL DATA"
        />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.id).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header
          title="STANDARD PROCTOR COMPACTION TEST"
          subtitle="ENTER TESTING DATA"
        />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <ProctorCompactionDetails
          isNonMobile={isNonMobile}
          chartData={chartData}
          setChartData={setChartData}
          calculationOfChart={calculationOfChart}
          calculationOfChartFinalVal={calculationOfChartFinalVal}
        />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Remarks"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default ProctorCompaction;
